import { render, staticRenderFns } from "./update-goods.vue?vue&type=template&id=62dad97e&scoped=true"
import script from "./update-goods.vue?vue&type=script&lang=js"
export * from "./update-goods.vue?vue&type=script&lang=js"
import style0 from "./update-goods.vue?vue&type=style&index=0&id=62dad97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dad97e",
  null
  
)

export default component.exports